/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPublicDocumentForEntityByHash } from '../fn/public-documents-controller/get-public-document-for-entity-by-hash';
import { GetPublicDocumentForEntityByHash$Params } from '../fn/public-documents-controller/get-public-document-for-entity-by-hash';
import { getPublicTmpDocumentByFilenameHash } from '../fn/public-documents-controller/get-public-tmp-document-by-filename-hash';
import { GetPublicTmpDocumentByFilenameHash$Params } from '../fn/public-documents-controller/get-public-tmp-document-by-filename-hash';

@Injectable({ providedIn: 'root' })
export class PublicDocumentsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPublicDocumentForEntityByHash()` */
  static readonly GetPublicDocumentForEntityByHashPath = '/public/documents/{downloadHash}';

  /**
   * starts the download stream of a document in the specific entity context
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicDocumentForEntityByHash()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicDocumentForEntityByHash$Response(params: GetPublicDocumentForEntityByHash$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getPublicDocumentForEntityByHash(this.http, this.rootUrl, params, context);
  }

  /**
   * starts the download stream of a document in the specific entity context
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicDocumentForEntityByHash$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicDocumentForEntityByHash(params: GetPublicDocumentForEntityByHash$Params, context?: HttpContext): Observable<Blob> {
    return this.getPublicDocumentForEntityByHash$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getPublicTmpDocumentByFilenameHash()` */
  static readonly GetPublicTmpDocumentByFilenameHashPath = '/public/documents/temp/{documentHash}';

  /**
   * starts the download stream
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicTmpDocumentByFilenameHash()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicTmpDocumentByFilenameHash$Response(params: GetPublicTmpDocumentByFilenameHash$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getPublicTmpDocumentByFilenameHash(this.http, this.rootUrl, params, context);
  }

  /**
   * starts the download stream
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicTmpDocumentByFilenameHash$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicTmpDocumentByFilenameHash(params: GetPublicTmpDocumentByFilenameHash$Params, context?: HttpContext): Observable<Blob> {
    return this.getPublicTmpDocumentByFilenameHash$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
